import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CButton from '@/components/shared/CButton';
import CLazy from '@/components/CLazy.vue';
import store from '@/store';
import { getEffectComponent } from '@/components/DesignStudio/ImageEffectsProperties/utils/componentMapper';
import { EffectType, ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import { CombinedPresets, PresetTag, Provider } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import ApiKeyRequirementFooter from './ApiKeyRequirementFooter/ApiKeyRequirementFooter.vue';

interface Props {
    effect: CombinedPresets | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectSelectedBody',
  props: {
    effect: { default: null }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update', value: ImageEffectType, provider?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { effect: CombinedPresets | null };

const formRef = ref<HTMLFormElement | null>(null)
const formData = ref<ImageEffectType | undefined>(undefined);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const currentEffectComponent = ref<any>(null);





const provider = ref<Provider | null>(null);

const selectedPreset = computed(() => {
    if (!props.effect?.presets) return;
    return props.effect.presets.find(preset => preset.effectConfig.presetId === provider.value?.id);
});

const loadEffectComponent = async (effectType: EffectType) => {
    try {
        currentEffectComponent.value = await getEffectComponent(effectType);
    } catch (error) {
        console.error('Error loading effect component:', error);
        currentEffectComponent.value = null;
    }
};

const submitForm = () => {
    formRef.value?.dispatchEvent(new Event('submit', { cancelable: true }))
}

const resetForm = () => {
    currentEffectComponent.value = null;
    store.dispatch('imageEffectsProperties/resetModalState');
};

const handleClose = () => {
    resetForm();
    if (!props.effect?.presets) {
        store.dispatch('imageEffectsProperties/closeAddModal');
    }
};


const handleSave = () => {
    if (formData.value && provider.value) emit('update', formData.value, provider.value?.id);
};

const setDefaultValuesToForm = () => {
    formData.value = undefined;
    if (!selectedPreset.value) return;
    const { type, presetId, ...defaultFormValues } = selectedPreset.value.effectConfig;
    formData.value = defaultFormValues as ImageEffectType;
};

watch(
    () => provider.value,
    () => {
        if (!provider.value?.id && props.effect?.presets) return
        if (props.effect?.presets) {
          setDefaultValuesToForm();
        }
        if (provider.value) loadEffectComponent(provider.value.type);
    },
    { deep: true, immediate: true }
);

watch(
    () => props.effect,
    () => {
        if (props.effect?.type) provider.value = {type: props.effect.type}
        if (props.effect?.formData) {
            formData.value = props.effect.formData
        }
        if (props.effect?.presets?.length) {
            let preset
            if (props.effect?.presets?.length === 1) {
                preset = props.effect?.presets[0]
            } else {
                preset = props.effect?.presets.find(presetOption => presetOption.tags.includes(PresetTag.CUSTOMILY)) || props.effect?.presets[0]
            }
            if (preset) provider.value = {type: preset.effectConfig.type, id: preset.id as EffectType}
            if (props.effect?.presets?.length === 1 && props.effect?.presets[0].tags.includes(PresetTag.CUSTOMILY)) {
                setDefaultValuesToForm();
                handleSave();
            }
        } 
    },
    { deep: true, immediate: true }
);

return { __sfc: true,formRef, formData, currentEffectComponent, emit, props, provider, selectedPreset, loadEffectComponent, submitForm, resetForm, handleClose, handleSave, setDefaultValuesToForm, CButton, CLazy, PresetTag, ApiKeyRequirementFooter }
}

})